/**
 * EBH 2026-09-18 — a 2.ª peça, na própria página do Halloween.
 *
 * O desconto não é novo nem é daqui: é a função «EBH Cross-sell — 2+ da mesma
 * família» (família «Halloween» em `custom.cross_sell_familia`), que desconta
 * 10% no checkout a partir de duas peças da coleção. Este ficheiro faz duas
 * coisas e mais nenhuma:
 *   1. põe a peça no saco SEM sair da página — quem sai do lookbook para o
 *      carrinho não volta para ver as outras três;
 *   2. abre o convite da 2.ª peça, e mostra o estado certo quando ela já lá está.
 *
 * ⚠️ Fala só com o que é público: /cart/add.js, /cart.js e o evento de DOM
 *    "apps:product-added-to-cart", que a gaveta do carrinho e o número do
 *    cabeçalho já escutam (o mesmo caminho do ebh-bundle-builder.js). O tema
 *    não expõe as suas funções de carrinho em `window`.
 * ⚠️ A gaveta NÃO se abre: abri-la tapava o convite, que é a razão de existir
 *    este ficheiro. Quem quiser o saco tem o botão do painel.
 * ⚠️ Delegação em `document`: a secção é redesenhada no editor de temas
 *    (shopify:section:load) e um listener preso ao formulário perder-se-ia.
 * ⚠️ A conta é `quantity`, não peças diferentes: duas canecas iguais também
 *    fazem os 10%.
 * ⚠️ Agrupar trabalho com setTimeout, nunca com requestAnimationFrame: em
 *    separador escondido o rAF fica pendurado e a marca nunca se limpa
 *    (feedback_raf_em_separador_escondido_fica_pendurado).
 * ⚠️ Sem JS nada disto existe e a página continua a vender: o formulário é um
 *    POST nativo para /cart/add.
 */
(function () {
  "use strict";

  var REVERTER_MS = 2200;

  function textos() {
    var s = document.querySelector("script[data-hw-textos]");
    return (s && s.dataset) || {};
  }

  function painel() {
    return document.querySelector("[data-hw-par]");
  }

  function idsDaColeccao(par) {
    return (par.getAttribute("data-hw-ids") || "")
      .split(",")
      .map(function (x) { return x.trim(); })
      .filter(Boolean);
  }

  function lerSaco() {
    return fetch("/cart.js", { credentials: "include" })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function porProduto(saco) {
    var mapa = {};
    if (!saco || !saco.items) return mapa;
    saco.items.forEach(function (it) {
      var id = String(it.product_id);
      mapa[id] = (mapa[id] || 0) + it.quantity;
    });
    return mapa;
  }

  // Desenha o painel a partir do SACO, não do que se clicou: quem chega com
  // uma peça de outra visita vê o estado certo à primeira.
  function desenhar(saco) {
    var par = painel();
    if (!par) return;
    var t = textos();
    var mapa = porProduto(saco);
    var ids = idsDaColeccao(par);
    var quantas = ids.reduce(function (n, id) { return n + (mapa[id] || 0); }, 0);

    par.hidden = quantas < 1;
    if (quantas < 1) return;

    var feito = quantas >= 2;
    var titulo = par.querySelector("[data-hw-titulo]");
    var nota = par.querySelector("[data-hw-nota]");
    var saco_btn = par.querySelector("[data-hw-saco]");
    if (titulo) titulo.textContent = feito ? (t.tituloFeito || titulo.textContent)
                                           : (t.tituloFalta || titulo.textContent);
    if (nota) nota.textContent = feito ? (t.notaFeito || nota.textContent)
                                       : (t.notaFalta || nota.textContent);
    if (saco_btn) saco_btn.hidden = !feito;
    par.classList.toggle("ebh-hw__par--feito", feito);

    // Uma peça que já está no saco sai das sugestões: sugerir o que a pessoa
    // acabou de comprar é ruído. Fica sempre pelo menos uma (a coleção tem
    // quatro e o desconto chega-se com duas).
    par.querySelectorAll("[data-hw-sug]").forEach(function (sug) {
      sug.hidden = !!mapa[sug.getAttribute("data-hw-prod")];
    });
  }

  function marcarBotao(form) {
    var t = textos();
    var rotulo = form.querySelector("[data-hw-rotulo]");
    if (!rotulo || !t.adicionado) return;
    rotulo.textContent = t.adicionado;
    form.classList.add("ebh-hw__form--feito");
    setTimeout(function () {
      rotulo.textContent = t.botao || rotulo.textContent;
      form.classList.remove("ebh-hw__form--feito");
    }, REVERTER_MS);
  }

  function juntar(form) {
    var id = form.querySelector('input[name="id"]');
    if (!id) return;
    var botao = form.querySelector("button");
    if (botao) botao.disabled = true;

    fetch("/cart/add.js", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id.value), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add " + r.status);
        return r.json();
      })
      .then(function () {
        // o número do cabeçalho e a gaveta actualizam-se com este evento
        document.dispatchEvent(new CustomEvent("apps:product-added-to-cart"));
        marcarBotao(form);
        return lerSaco().then(desenhar);
      })
      .catch(function () {
        // Falhar calado seria prometer um saco que não tem nada lá dentro:
        // devolve-se a pessoa ao caminho nativo, que trata o erro na loja.
        form.removeAttribute("data-hw-form");
        form.submit();
      })
      .then(function () {
        if (botao) botao.disabled = false;
      });
  }

  document.addEventListener("submit", function (e) {
    var form = e.target.closest && e.target.closest("[data-hw-form]");
    if (!form) return;
    e.preventDefault();
    juntar(form);
  });

  function arrancar() {
    if (!painel()) return;
    lerSaco().then(desenhar);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", arrancar);
  } else {
    arrancar();
  }
  document.addEventListener("shopify:section:load", function () { setTimeout(arrancar, 0); });
})();
